import React, { useState, useEffect, Suspense, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const Register = React.lazy(() => import('../pages/Buyer/Register/Register'));

const checkAuthStatus = () => {
    const token = localStorage.getItem("ACCESS_TOKEN");
    const isProfileComplete = localStorage.getItem("isProfileComplete") === "true";
    return Boolean(token && isProfileComplete);
};

// 🔹 بررسی مطمئن حضور در محیط تلگرام
const isInsideTelegram = () => {
    const tg = window.Telegram?.WebApp;
    return Boolean(
        tg?.initDataUnsafe?.user?.id ||
        (tg?.initData && tg.initData.trim() !== '') ||
        window.location.hash.includes('tgWebAppData')
    );
};

const ProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const [isShowRegister, setIsShowRegister] = useState(false);
    const [isAuthorized, setIsAuthorized] = useState(checkAuthStatus);

    useEffect(() => {
        const syncAuth = () => {
            setIsAuthorized(checkAuthStatus());
        };

        window.addEventListener('profileUpdated', syncAuth);
        window.addEventListener('storage', syncAuth);

        return () => {
            window.removeEventListener('profileUpdated', syncAuth);
            window.removeEventListener('storage', syncAuth);
        };
    }, []);

    const handleCloseRegister = useCallback(() => {
        setIsShowRegister(false);
        const currentAuth = checkAuthStatus();
        setIsAuthorized(currentAuth);

        if (!currentAuth) {
            navigate('/', { replace: true });
        }
    }, [navigate]);

    useEffect(() => {
        let isMounted = true;

        if (!isAuthorized && !isShowRegister) {
            const hasToken = Boolean(localStorage.getItem("ACCESS_TOKEN"));
            const inTelegram = isInsideTelegram();

            // 👈 اگر کاربر خارج از تلگرام است و هیچ توکنی ندارد، نیازی به SweetAlert نیست؛ مستقیم برود به لاگین
            if (!inTelegram && !hasToken) {
                navigate('/login', { replace: true });
                return;
            }

            Swal.fire({
                title: hasToken ? 'تکمیل اطلاعات کاربری' : 'نیاز به ورود / ثبت‌نام',
                html: `<div style="font-size: 0.95rem; line-height: 1.8; color: #444;">
                         ${hasToken
                            ? 'برای دسترسی به این بخش، لطفاً اطلاعات کاربری خود را تکمیل کنید.'
                            : 'برای دسترسی به این بخش، ابتدا باید وارد حساب کاربری خود شوید.'}
                       </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#007aff',
                cancelButtonColor: '#e5e5ea',
                confirmButtonText: `<span style="font-weight: bold; font-size:0.85rem">${hasToken ? 'تکمیل اطلاعات' : 'ورود / ثبت‌نام'}</span>`,
                cancelButtonText: '<span style="color: #1c1c1e; font-weight: bold; font-size:0.85rem">انصراف</span>',
                reverseButtons: false,
                width: '85%',
                padding: '2em 1em',
                backdrop: 'rgba(0,0,0,0.4)',
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    const confirmBtn = Swal.getConfirmButton();
                    const cancelBtn = Swal.getCancelButton();
                    if (confirmBtn) {
                        confirmBtn.style.borderRadius = '10px';
                        confirmBtn.style.padding = '12px 20px';
                        confirmBtn.style.minWidth = '110px';
                    }
                    if (cancelBtn) {
                        cancelBtn.style.borderRadius = '10px';
                        cancelBtn.style.padding = '12px 20px';
                        cancelBtn.style.minWidth = '110px';
                    }
                }
            }).then((result) => {
                if (!isMounted) return;

                if (result.isConfirmed) {
                    // 👈 اگر توکن نداشت و خارج تلگرام بود به صفحه لاگین هدایت شود
                    if (!hasToken && !inTelegram) {
                        navigate('/login');
                    } else {
                        setIsShowRegister(true);
                    }
                } else if (
                    result.isDismissed ||
                    result.dismiss === Swal.DismissReason.cancel ||
                    result.dismiss === Swal.DismissReason.backdrop
                ) {
                    navigate('/', { replace: true });
                }
            });
        }

        return () => {
            isMounted = false;
            if (Swal.isVisible()) {
                Swal.close();
            }
        };
    }, [isAuthorized, isShowRegister, navigate]);

    if (isAuthorized) {
        return children;
    }

    return (
        <div style={{ minHeight: '100vh', width: '100%', position: 'relative' }}>
            <Suspense fallback={null}>
                {isShowRegister && (
                    <Register
                        fn_close={handleCloseRegister}
                        isShow={isShowRegister}
                    />
                )}
            </Suspense>
        </div>
    );
};

export default ProtectedRoute;
